module.exports = __webpack_public_path__ + "img/heart_map.93bc53ce.png";